import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class CoreService {

    sidebarOpen = true;

    fullscreen: HTMLElement;
    element: HTMLElement;

    isCheckboxOpen = false;

    layout: any = 'ltr';
    rtlStatus = false;


    constructor(
        private dialog: MatDialog,
        private toastr: ToastrService) {
    }

}
